<template>
<div class="chapter">
<div class="inner_page">
<p class="C116"><a id="page_xiii">Prefatory Note</a></p><a id="page_xiii">
<p class="C645">Those who have read and understood the preceding parts of this work know that they should not expect a new beginning, much less a conclusion. In fact, we must decisively call into question the commonplace according to which is it a good rule that an inquiry commence with a <em>pars destruens</em> and conclude with a <em>pars construens</em> and, moreover, that the two parts be substantially and formally distinct. In a philosophical inquiry, not only can the <em>pars destruens</em> not be separated from the <em>pars construens</em>, but the latter coincides, at every point and without remainder, with the former. A theory that, to the extent possible, has cleared the field of all errors has, with that, exhausted its raison d’être and cannot presume to subsist as separate from practice. The <em>archè</em> that archeology brings to light is not homogeneous to the presuppositions that it has neutralized; it is given entirely and only in their collapse. Its work is their inoperativity.</p>
<p class="C559">The reader will thus find here reflections on some concepts—use, demand, mode, form-of-life, inoperativity, destituent potential—that have from the very beginning oriented an investigation that, like every work of poetry and of thought, cannot be concluded but only abandoned (and perhaps continued by others).</p>
<p class="C433">Some of the texts published here were written at the beginning of the investigation, which is to say, almost twenty years ago; others—the greater part—were written in the course of the last five years. The reader will understand that, in a writing process so prolonged in time, it is difficult to avoid repetitions and, at times, discordances.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Prefatory_Note.vue?f533ce64